import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { 
  setCurrentDropdownGroup, 
  applyCurrentDropdownGroupToSelectedDropdownValues
} from '../redux/store/genericReportingSlice';

/**
 * Provider component that automatically updates the current dropdown group based on URL
 * Maps URL paths to dropdown group names for automatic state management
 */
export const DropdownGroupProvider = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  
  const currentDropdownGroup = useSelector((state) => state.genericReporting.currentDropdownGroup);
  const selectedDropdownValuesPerDropdownGroup = useSelector((state) => state.genericReporting.selectedDropdownValuesPerDropdownGroup);

  // URL to dropdown group mapping
  const getDropdownGroupFromUrl = (pathname) => {
    // Remove leading slash and split path
    const path = pathname.replace(/^\//, '');
    const pathParts = path.split('/');
    
    // Map different URL patterns to dropdown groups
    switch (pathParts[0]) {
      case 'performance':
        if (pathParts[1] === 'site-analytics') {
          return 'site_analytics';
        }
        return 'default';
      case 'settings':
        return 'settings';
      case 'influencer':
        if (pathParts[1] === 'content') {
          return 'influencer_content';
        }
        return 'influencer_analytics';
      default:
        return 'default';
    }
  };

  // Update dropdown group when URL changes
  useEffect(() => {
    const newDropdownGroup = getDropdownGroupFromUrl(location.pathname);
    
    // Only update if the group is different
    if (newDropdownGroup !== currentDropdownGroup) {
      dispatch(setCurrentDropdownGroup(newDropdownGroup));
    }
  }, [location.pathname, currentDropdownGroup, dispatch]);

  // Apply current group values when group changes
  useEffect(() => {
    if (currentDropdownGroup && selectedDropdownValuesPerDropdownGroup[currentDropdownGroup]) {
      dispatch(applyCurrentDropdownGroupToSelectedDropdownValues());
    }
  }, [currentDropdownGroup, selectedDropdownValuesPerDropdownGroup, dispatch]);

  return children;
};

export default DropdownGroupProvider;
